export default {
  KITCHENS: (state) => state.kitchens,
  SELECTED: (state) => state.selected,
  DELIVERY: (state) => state.delivery,
  SELECTED_DELIVERY: (state) => state.selectedDelivery,
};
